import { useState } from "react"
import { connect } from "react-redux"
import { Navigate, Link } from "react-router-dom";
import { create, load_user } from "../../redux/actions/auth/auth"

function Login({
  create,
  load_user,
  isAuthenticated,
  info
}) {

  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });

  const {
    email,
    password
  } = formData;

  const onChange = e => setFormData({ ...formData, [e.target.name]: e.target.value});

  const onSubmit = e => {
      e.preventDefault();
      create(email, password)
  }

  if(isAuthenticated){
    load_user()
    return <Navigate to='/'/>
  }
  else{
    return (
      <>
        <div className="fixed inset-0 flex flex-1 flex-col justify-center mt-10 px-6 lg:px-8">

          <div className="sm:mx-auto sm:w-full sm:max-w-sm">
            <h2 className="mt-10 text-center text-5xl font-bold leading-9 text-gray-900 mb-5">
              Inicia Sesión
            </h2> 
          </div>
  
          <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
            <form onSubmit={e=>{onSubmit(e)}} method='POST' className="space-y-6">
              <div>
                <label htmlFor="email" className="block text-sm font-medium leading-6 text-gray-900">
                  Email
                </label>
                <div className="mt-2">
                  <input
                    id="email"
                    name="email"
                    type="email"
                    value={email}
                    onChange={e=>onChange(e)}
                    required
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-green sm:text-sm sm:leading-6"
                  />
                </div>
              </div>
  
              <div>
                <div className="flex items-center justify-between">
                  <label htmlFor="password" className="block text-sm font-medium leading-6 text-gray-900">
                    Contraseña
                  </label>
                  <div className="text-sm">
                    <Link to="/forgot_password" className="font-semibold text-blue-green hover:text-blue-green-dark">
                      ¿Olvidaste la contraseña?
                    </Link>
                  </div>
                </div>
                <div className="mt-2">
                  <input
                    id="password"
                    name="password"
                    type="password"
                    value={password}
                    onChange={e=>onChange(e)}                                                                                                                                                                 
                    required
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-green sm:text-sm sm:leading-6"
                  />
                </div>
              </div>
  
              <div>
                <button
                  type="submit"
                  className="flex w-full justify-center rounded-md bg-blue-green px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-blue-green-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-green"
                >
                  Iniciar Sesion
                </button>
              </div>
              <p className="text-red-600">{info}</p>
            </form>
  
            <p className="mt-10 text-center text-sm text-gray-500">
              ¿No tienes cuenta?{' '}
              <Link to="/register" className="font-semibold leading-6 text-blue-green hover:text-blue-green-dark">
                Registrarse
              </Link>
            </p>
          </div>
        </div>
      </>
    )
  }
  }
  
const mapStateToProps=state=>({
  isAuthenticated: state.auth.isAuthenticated,
  info: state.auth.info
})

export default connect (mapStateToProps, {
    create,
    load_user
})(Login)